import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { c as cx } from './index-tZvMCc77.js';
import { u as useLayoutPropsUtil } from './useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js';

import './Icon-BBWg60pO.css';const icon = "_icon_15ocm_3";
const small = "_small_15ocm_34";
const medium = "_medium_15ocm_37";
const large = "_large_15ocm_40";
const xlarge = "_xlarge_15ocm_43";
const styles = {
	icon: icon,
	small: small,
	medium: medium,
	large: large,
	xlarge: xlarge
};

const Icon = forwardRef((props, ref) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
  const {
    size = "medium",
    className,
    svg: Svg2,
    inherit,
    style,
    color,
    ...rest
  } = componentProps;
  const iconClassNames = cx([styles["icon"]], className, {
    [styles["small"]]: size === "small",
    [styles["medium"]]: size === "medium",
    [styles["large"]]: size === "large",
    [styles["xlarge"]]: size === "xlarge"
  });
  const styleCombined = {
    color: color ? color : inherit ? "inherit" : void 0,
    ...style,
    ...layoutStyles
  };
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: iconClassNames,
      "data-anv": "icon",
      style: styleCombined,
      ref,
      ...rest,
      children: /* @__PURE__ */ jsx(Svg2, {})
    }
  );
});
Icon.displayName = "Icon";

export { Icon as I };
//# sourceMappingURL=Icon-BBWg60pO-Dja0R43O.js.map
